module.exports = __webpack_public_path__ + "static/media/kitchen.3c0b3838.svg";